import {
  funcScrollControl,
  funcLoad,
  comMain,
  comMain2,
} from './index';

const funcEntry = (() => {


  funcScrollControl.noScroll();


  if (document.querySelector("body#pageTop") !== null) {
    document.addEventListener("DOMContentLoaded", () => {
      funcLoad()
    });
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      funcLoad()
      comMain()
      comMain2()
    });
  }


})();
export default funcEntry;